(function () {
  'use strict';

  /* =========================================================
     AVERNOZA BUNDLE FINAL VERSION

     特殊产品：
     https://avernoza.com/products/sdsd001

     sdsd001：
     Price = $26.98
     Compare-at price = $49.00

     最终显示：
     Buy 1  $26.98 / $49
     Buy 2  $48.56 / $98
     Buy 3  $68.80 / $147
     Buy 4  $86.34 / $196

     其他产品完全保持原来的逻辑。
  ========================================================= */

  const SPECIAL_PRODUCT_HANDLE = 'sdsd001';

  const DISCOUNTS = {
    1: 0,
    2: 10,
    3: 15,
    4: 20
  };

  /* =========================================================
     金额格式
  ========================================================= */

  function formatMoney(cents) {
    const value = Number(cents || 0);

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value / 100);
  }

  /* =========================================================
     从网址获取产品 handle

     例如：
     /products/sdsd001
     =>
     sdsd001
  ========================================================= */

  function getHandleFromUrl() {
    const path = window.location.pathname || '';

    const match = path.match(/\/products\/([^/?#]+)/i);

    if (!match || !match[1]) {
      return '';
    }

    return decodeURIComponent(match[1]);
  }

  /* =========================================================
     获取当前产品 handle

     优先读取 HTML data-product-handle
     如果没有，则直接读取网址
  ========================================================= */

  function getProductHandle(root) {
    if (
      root &&
      root.dataset &&
      root.dataset.productHandle
    ) {
      return root.dataset.productHandle;
    }

    return getHandleFromUrl();
  }

  /* =========================================================
     是否为 sdsd001
  ========================================================= */

  function isSpecialProduct(root) {
    return (
      getProductHandle(root) ===
      SPECIAL_PRODUCT_HANDLE
    );
  }

  /* =========================================================
     获取这个 Variant 的套餐划线单价

     sdsd001：
     使用 compare_at_price

     其他产品：
     继续使用 price

     所以不会修改原来的灯帘产品
  ========================================================= */

  function getCompareUnitPrice(root, variant) {
    if (!variant) {
      return 0;
    }

    const price = Number(
      variant.price || 0
    );

    const compareAtPrice = Number(
      variant.compare_at_price || 0
    );

    if (
      isSpecialProduct(root) &&
      compareAtPrice > price
    ) {
      return compareAtPrice;
    }

    return price;
  }

  /* =========================================================
     初始化
  ========================================================= */

  function initBundle(root) {
    if (!root) {
      return;
    }

    /*
    防止重复初始化
    */
    if (
      root.dataset.avernozaFinalReady ===
      'true'
    ) {
      return;
    }

    root.dataset.avernozaFinalReady =
      'true';

    const variantsScript =
      root.querySelector(
        '[data-avernoza-variants]'
      );

    if (!variantsScript) {
      console.warn(
        'Avernoza bundle: variants JSON not found.'
      );

      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(
        variantsScript.textContent
      );
    } catch (error) {
      console.error(
        'Avernoza bundle JSON error:',
        error
      );

      return;
    }

    if (!Array.isArray(variants)) {
      return;
    }

    const cards = Array.from(
      root.querySelectorAll(
        '.avernoza-bundle__card[data-bundle-qty]'
      )
    );

    if (!cards.length) {
      return;
    }

    let selectedQty = 1;

    /* =======================================================
       获取当前 Variant
    ======================================================= */

    function getCurrentVariant() {
      const section =
        root.closest('section') ||
        document;

      /*
      先读产品表单隐藏的 variant id
      */

      const variantInput =
        section.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );

      if (
        variantInput &&
        variantInput.value
      ) {
        const foundById =
          variants.find(function (variant) {
            return (
              Number(variant.id) ===
              Number(
                variantInput.value
              )
            );
          });

        if (foundById) {
          return foundById;
        }
      }

      /*
      再读当前选中的 radio / dropdown
      */

      const selectedValues = [];

      section
        .querySelectorAll(
          'variant-selects input[type="radio"]:checked'
        )
        .forEach(function (input) {
          selectedValues.push(
            input.value
          );
        });

      section
        .querySelectorAll(
          'variant-selects select'
        )
        .forEach(function (select) {
          if (select.value) {
            selectedValues.push(
              select.value
            );
          }
        });

      if (selectedValues.length) {
        const matchedVariant =
          variants.find(function (variant) {
            if (
              !Array.isArray(
                variant.options
              )
            ) {
              return false;
            }

            return selectedValues.every(
              function (value) {
                return variant.options.includes(
                  value
                );
              }
            );
          });

        if (matchedVariant) {
          return matchedVariant;
        }
      }

      /*
      最后兜底
      */

      return (
        variants.find(function (variant) {
          return variant.available;
        }) ||
        variants[0] ||
        null
      );
    }

    /* =======================================================
       获取卡片标题区域
    ======================================================= */

    function getMainArea(card) {
      return card.querySelector(
        '.avernoza-bundle__main'
      );
    }

    /* =======================================================
       更新 You save
    ======================================================= */

    function updateSaveText(
      card,
      compareTotal,
      saleTotal
    ) {
      const main =
        getMainArea(card);

      if (!main) {
        return;
      }

      let saveSpan =
        main.querySelector('span');

      /*
      Buy 1 原代码可能没有 span，
      自动创建
      */
      if (!saveSpan) {
        saveSpan =
          document.createElement(
            'span'
          );

        main.appendChild(saveSpan);
      }

      if (isSpecialProduct(root)) {
        const saving =
          Math.max(
            0,
            compareTotal -
              saleTotal
          );

        saveSpan.textContent =
          'You save ' +
          formatMoney(saving);
      }
    }

    /* =======================================================
       更新默认 Buy 1 / Buy 2 / Buy 3 / Buy 4
    ======================================================= */

    function updateBundlePrices() {
      const currentVariant =
        getCurrentVariant();

      if (!currentVariant) {
        return;
      }

      const saleUnitPrice =
        Number(
          currentVariant.price || 0
        );

      const compareUnitPrice =
        getCompareUnitPrice(
          root,
          currentVariant
        );

      cards.forEach(function (card) {
        const qty =
          Number(
            card.dataset.bundleQty ||
              1
          );

        const discount =
          DISCOUNTS[qty] || 0;

        /*
        折扣前实际售价总额
        */

        const regularSaleTotal =
          saleUnitPrice * qty;

        /*
        实际成交价
        */

        const saleTotal =
          Math.round(
            regularSaleTotal *
              (1 -
                discount / 100)
          );

        /*
        最终划线原价
        */

        const compareTotal =
          compareUnitPrice * qty;

        const priceEl =
          card.querySelector(
            '[data-bundle-price]'
          );

        const compareEl =
          card.querySelector(
            '[data-bundle-compare]'
          );

        /*
        售价
        */

        if (priceEl) {
          priceEl.textContent =
            formatMoney(
              saleTotal
            );
        }

        /*
        ======================================
        sdsd001
        ======================================
        */

        if (isSpecialProduct(root)) {
          if (compareEl) {
            compareEl.textContent =
              formatMoney(
                compareTotal
              );

            compareEl.style.display =
              '';
          }

          updateSaveText(
            card,
            compareTotal,
            saleTotal
          );

          return;
        }

        /*
        ======================================
        其他原来的产品

        保持旧价格逻辑
        ======================================
        */

        if (!compareEl) {
          return;
        }

        if (qty === 1) {
          compareEl.textContent = '';

          compareEl.style.display =
            'none';

          return;
        }

        compareEl.textContent =
          formatMoney(
            regularSaleTotal
          );

        compareEl.style.display =
          '';
      });
    }

    /* =======================================================
       清理下拉框
    ======================================================= */

    function clearSelectors() {
      root
        .querySelectorAll(
          '[data-bundle-selectors]'
        )
        .forEach(function (wrapper) {
          wrapper.innerHTML = '';
          wrapper.hidden = true;
        });
    }

    /* =======================================================
       生成 #1 #2 #3 #4
    ======================================================= */

    function buildSelectors(
      card,
      qty
    ) {
      clearSelectors();

      if (!card || qty <= 1) {
        return;
      }

      const wrapper =
        card.querySelector(
          '[data-bundle-selectors]'
        );

      if (!wrapper) {
        return;
      }

      const currentVariant =
        getCurrentVariant();

      wrapper.hidden = false;

      for (
        let index = 1;
        index <= qty;
        index++
      ) {
        const row =
          document.createElement(
            'div'
          );

        row.className =
          'avernoza-mix-row';

        const number =
          document.createElement(
            'strong'
          );

        number.className =
          'avernoza-mix-number';

        number.textContent =
          '#' + index;

        const select =
          document.createElement(
            'select'
          );

        select.className =
          'avernoza-mix-select';

        select.setAttribute(
          'data-bundle-variant',
          ''
        );

        variants.forEach(function (
          variant
        ) {
          if (
            variant.available ===
            false
          ) {
            return;
          }

          const option =
            document.createElement(
              'option'
            );

          option.value =
            variant.id;

          option.textContent =
            variant.title;

          if (
            currentVariant &&
            Number(
              currentVariant.id
            ) ===
              Number(
                variant.id
              )
          ) {
            option.selected = true;
          }

          select.appendChild(
            option
          );
        });

        select.addEventListener(
          'change',
          function () {
            updateMixPrice();
          }
        );

        row.appendChild(number);

        row.appendChild(select);

        wrapper.appendChild(row);
      }

      updateMixPrice();
    }

    /* =======================================================
       Mix & Match 价格
    ======================================================= */

    function updateMixPrice() {
      const activeCard =
        root.querySelector(
          '.avernoza-bundle__card.is-active'
        );

      if (!activeCard) {
        return;
      }

      const qty =
        Number(
          activeCard.dataset.bundleQty ||
            1
        );

      if (qty <= 1) {
        updateBundlePrices();
        return;
      }

      const discount =
        DISCOUNTS[qty] || 0;

      const selects =
        Array.from(
          activeCard.querySelectorAll(
            '[data-bundle-variant]'
          )
        );

      if (!selects.length) {
        return;
      }

      let saleBeforeDiscount = 0;
      let compareTotal = 0;

      selects.forEach(function (
        select
      ) {
        const variant =
          variants.find(function (
            item
          ) {
            return (
              Number(item.id) ===
              Number(
                select.value
              )
            );
          });

        if (!variant) {
          return;
        }

        const price =
          Number(
            variant.price || 0
          );

        saleBeforeDiscount +=
          price;

        compareTotal +=
          getCompareUnitPrice(
            root,
            variant
          );
      });

      const saleTotal =
        Math.round(
          saleBeforeDiscount *
            (1 -
              discount / 100)
        );

      const priceEl =
        activeCard.querySelector(
          '[data-bundle-price]'
        );

      const compareEl =
        activeCard.querySelector(
          '[data-bundle-compare]'
        );

      if (priceEl) {
        priceEl.textContent =
          formatMoney(
            saleTotal
          );
      }

      /*
      sdsd001
      */
      if (isSpecialProduct(root)) {
        if (compareEl) {
          compareEl.textContent =
            formatMoney(
              compareTotal
            );

          compareEl.style.display =
            '';
        }

        updateSaveText(
          activeCard,
          compareTotal,
          saleTotal
        );

        return;
      }

      /*
      原产品
      */
      if (compareEl) {
        compareEl.textContent =
          formatMoney(
            saleBeforeDiscount
          );

        compareEl.style.display =
          '';
      }
    }

    /* =======================================================
       选择套餐
    ======================================================= */

    function selectCard(card) {
      if (!card) {
        return;
      }

      cards.forEach(function (item) {
        item.classList.remove(
          'is-active'
        );
      });

      card.classList.add(
        'is-active'
      );

      selectedQty =
        Number(
          card.dataset.bundleQty ||
            1
        );

      updateBundlePrices();

      buildSelectors(
        card,
        selectedQty
      );
    }

    /* =======================================================
       点击 Buy 1 / 2 / 3 / 4
    ======================================================= */

    cards.forEach(function (card) {
      const trigger =
        card.querySelector(
          '.avernoza-bundle__trigger'
        );

      if (trigger) {
        trigger.addEventListener(
          'click',
          function (event) {
            event.preventDefault();

            selectCard(card);
          }
        );
      }
    });

    /* =======================================================
       主规格切换

       Christmas Series
       Halloween Series
    ======================================================= */

    const section =
      root.closest('section') ||
      document;

    section.addEventListener(
      'change',
      function (event) {
        if (
          event.target.matches(
            '.avernoza-mix-select'
          )
        ) {
          return;
        }

        if (
          !event.target.closest(
            'variant-selects'
          )
        ) {
          return;
        }

        setTimeout(
          function () {
            updateBundlePrices();

            const activeCard =
              root.querySelector(
                '.avernoza-bundle__card.is-active'
              );

            if (
              activeCard &&
              selectedQty > 1
            ) {
              buildSelectors(
                activeCard,
                selectedQty
              );
            }
          },
          120
        );
      }
    );

    /* =======================================================
       初始显示
    ======================================================= */

    updateBundlePrices();

    const activeCard =
      root.querySelector(
        '.avernoza-bundle__card.is-active'
      );

    const firstCard =
      activeCard ||
      root.querySelector(
        '.avernoza-bundle__card[data-bundle-qty="1"]'
      ) ||
      cards[0];

    if (firstCard) {
      selectCard(firstCard);
    }
  }

  /* =========================================================
     初始化页面全部 Bundle
  ========================================================= */

  function initAll() {
    document
      .querySelectorAll(
        '[data-avernoza-bundle]'
      )
      .forEach(function (root) {
        initBundle(root);
      });
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }

  /*
  Shopify 编辑器重新加载 Section
  */

  document.addEventListener(
    'shopify:section:load',
    initAll
  );
})();